import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutGalleryScroll = {
  factory: EElement({
    id: '84eb3c02-ce32-a15d-5e28-fea11c845037',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('45fe2a95-816d-5aa9-7687-cdb7d8fd4285')]),
      children: EList([
        EElement({
          id: '0b9cf691-b3c4-9a5e-6e26-53ecb5492136',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: 'aa3d8ee5-1062-764b-c976-105542a9daba',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('916ee694-47ba-1d95-3e1c-70b5cf389d87'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'aa3d8ee5-1062-764b-c976-105542a9dabb',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                            medium: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 2'),
                                gridColumnEnd: EText('span 2'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                            tiny: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('0b18eff6-31dd-044f-db61-66904ddcb3be'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'f770f268-d35b-0b75-24fd-df0b0f420bea',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"section","domId":"aedb2846-c2f5-1ec9-a010-1a88204d866d"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('cf7caa89-d314-3574-0a3d-36f50dcba0be'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'f770f268-d35b-0b75-24fd-df0b0f420beb',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Virtual booths'),
                                }),
                                EElement({
                                  id: 'fe7f4029-45d0-ac29-94db-58989817736d',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('LineBreak')
                                  ),
                                  data: ERecord({}),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'bcd8627e-2f68-8d83-ccb2-d5d1af8e7bb5',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"section","domId":"9cfa1e7a-db2a-2bd1-6db7-ffcc0b35e9ac"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('cf7caa89-d314-3574-0a3d-36f50dcba0be'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'bcd8627e-2f68-8d83-ccb2-d5d1af8e7bb6',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Access to dashboard'),
                                }),
                                EElement({
                                  id: 'bcd8627e-2f68-8d83-ccb2-d5d1af8e7bb7',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('LineBreak')
                                  ),
                                  data: ERecord({}),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'e2ea0ba0-5328-add0-8f27-4dc67e92509c',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"section","domId":"3fd4af4f-a06f-4d88-47b3-3b605a4cca69"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('cf7caa89-d314-3574-0a3d-36f50dcba0be'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'e2ea0ba0-5328-add0-8f27-4dc67e92509d',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Lead retrieval'),
                                }),
                                EElement({
                                  id: 'e2ea0ba0-5328-add0-8f27-4dc67e92509e',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('LineBreak')
                                  ),
                                  data: ERecord({}),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '1f8c7d41-aeea-2dcd-b33a-32f4a9851b91',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"section","domId":"714c5d48-5208-eba1-c5a9-5f7b36256ae2"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('cf7caa89-d314-3574-0a3d-36f50dcba0be'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '1f8c7d41-aeea-2dcd-b33a-32f4a9851b92',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Lead scoring'),
                                }),
                                EElement({
                                  id: '1f8c7d41-aeea-2dcd-b33a-32f4a9851b93',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('LineBreak')
                                  ),
                                  data: ERecord({}),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '81ede380-39a2-b9f2-75a8-327b1f28f864',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"section","domId":"4255b2b0-22eb-623b-366b-d99d2c38300e"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('cf7caa89-d314-3574-0a3d-36f50dcba0be'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '81ede380-39a2-b9f2-75a8-327b1f28f865',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Sponsored sections'),
                                }),
                                EElement({
                                  id: '81ede380-39a2-b9f2-75a8-327b1f28f866',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('LineBreak')
                                  ),
                                  data: ERecord({}),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'aa3d8ee5-1062-764b-c976-105542a9dacc',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 2'),
                                gridColumnEnd: EText('span 2'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                            tiny: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('0aedf519-3b74-1865-e2e4-926f45382757'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'aedb2846-c2f5-1ec9-a010-1a88204d866d',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              text: EBoolean(false),
                              attr: ERecord({
                                id: EText('virtual-booths'),
                              }),
                              styleBlockIds: EList([
                                EText('560188c9-bb3e-d11f-21ba-bbadfd20abce'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'aa3d8ee5-1062-764b-c976-105542a9dacd',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.placeholderImageSun),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    style: ERecord({
                                      base: ERecord({
                                        main: ERecord({
                                          noPseudo: ERecord({
                                            gridColumnStart: EText('span 1'),
                                            gridColumnEnd: EText('span 1'),
                                            gridRowStart: EText('span 1'),
                                            gridRowEnd: EText('span 1'),
                                          }),
                                        }),
                                      }),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272d15f5e2b4b5092a61227"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        '8ce3839e-2a35-149b-8c70-921387a656ed'
                                      ),
                                      EText(
                                        '89b50107-cd85-1ac0-949b-4d4b42a224f4'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '7d185323-b87e-f9a7-a244-61534a60ff29',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Heading')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('h3'),
                                    styleBlockIds: EList([
                                      EText(
                                        'b923fc46-ce8e-0dc7-eabd-159942483cee'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '5f79f06f-3acf-c89b-06b8-6e27ce9c877b',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Virtual booths'),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '9cfa1e7a-db2a-2bd1-6db7-ffcc0b35e9ac',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              text: EBoolean(false),
                              attr: ERecord({
                                id: EText('access-dash'),
                              }),
                              styleBlockIds: EList([
                                EText('560188c9-bb3e-d11f-21ba-bbadfd20abce'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'aa3d8ee5-1062-764b-c976-105542a9dace',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(
                                        images.placeholderImageBalance
                                      ),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    style: ERecord({
                                      base: ERecord({
                                        main: ERecord({
                                          noPseudo: ERecord({
                                            gridColumnStart: EText('span 1'),
                                            gridColumnEnd: EText('span 1'),
                                            gridRowStart: EText('span 1'),
                                            gridRowEnd: EText('span 1'),
                                          }),
                                        }),
                                      }),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272d15f5e2b4b5092a61220"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        '8ce3839e-2a35-149b-8c70-921387a656ed'
                                      ),
                                      EText(
                                        '89b50107-cd85-1ac0-949b-4d4b42a224f4'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: 'bfab42ac-6847-d657-8689-312e85d7300e',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Heading')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('h3'),
                                    styleBlockIds: EList([
                                      EText(
                                        'b923fc46-ce8e-0dc7-eabd-159942483cee'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'bfab42ac-6847-d657-8689-312e85d7300f',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Access to dashboard'),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '3fd4af4f-a06f-4d88-47b3-3b605a4cca69',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              text: EBoolean(false),
                              attr: ERecord({
                                id: EText('lead-retrieval'),
                              }),
                              styleBlockIds: EList([
                                EText('560188c9-bb3e-d11f-21ba-bbadfd20abce'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '3fd4af4f-a06f-4d88-47b3-3b605a4cca6a',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(
                                        images.placeholderImageOverlap
                                      ),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    style: ERecord({
                                      base: ERecord({
                                        main: ERecord({
                                          noPseudo: ERecord({
                                            gridColumnStart: EText('span 1'),
                                            gridColumnEnd: EText('span 1'),
                                            gridRowStart: EText('span 1'),
                                            gridRowEnd: EText('span 1'),
                                          }),
                                        }),
                                      }),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272d15f5e2b4b5092a61235"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        '8ce3839e-2a35-149b-8c70-921387a656ed'
                                      ),
                                      EText(
                                        '89b50107-cd85-1ac0-949b-4d4b42a224f4'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '3fd4af4f-a06f-4d88-47b3-3b605a4cca6b',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Heading')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('h3'),
                                    styleBlockIds: EList([
                                      EText(
                                        'b923fc46-ce8e-0dc7-eabd-159942483cee'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '3fd4af4f-a06f-4d88-47b3-3b605a4cca6c',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Lead retrieval'),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '714c5d48-5208-eba1-c5a9-5f7b36256ae2',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              text: EBoolean(false),
                              attr: ERecord({
                                id: EText('lead-scoring'),
                              }),
                              styleBlockIds: EList([
                                EText('560188c9-bb3e-d11f-21ba-bbadfd20abce'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '714c5d48-5208-eba1-c5a9-5f7b36256ae3',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(
                                        images.placeholderImageMountains
                                      ),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    style: ERecord({
                                      base: ERecord({
                                        main: ERecord({
                                          noPseudo: ERecord({
                                            gridColumnStart: EText('span 1'),
                                            gridColumnEnd: EText('span 1'),
                                            gridRowStart: EText('span 1'),
                                            gridRowEnd: EText('span 1'),
                                          }),
                                        }),
                                      }),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272d15f5e2b4b5092a6123e"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        '8ce3839e-2a35-149b-8c70-921387a656ed'
                                      ),
                                      EText(
                                        '89b50107-cd85-1ac0-949b-4d4b42a224f4'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '714c5d48-5208-eba1-c5a9-5f7b36256ae4',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Heading')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('h3'),
                                    styleBlockIds: EList([
                                      EText(
                                        'b923fc46-ce8e-0dc7-eabd-159942483cee'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '714c5d48-5208-eba1-c5a9-5f7b36256ae5',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Lead scoring'),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '4255b2b0-22eb-623b-366b-d99d2c38300e',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              text: EBoolean(false),
                              attr: ERecord({
                                id: EText('sponsored-sections'),
                              }),
                              styleBlockIds: EList([
                                EText('560188c9-bb3e-d11f-21ba-bbadfd20abce'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '4255b2b0-22eb-623b-366b-d99d2c38300f',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(
                                        images.placeholderImageGallery
                                      ),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    style: ERecord({
                                      base: ERecord({
                                        main: ERecord({
                                          noPseudo: ERecord({
                                            gridColumnStart: EText('span 1'),
                                            gridColumnEnd: EText('span 1'),
                                            gridRowStart: EText('span 1'),
                                            gridRowEnd: EText('span 1'),
                                          }),
                                        }),
                                      }),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272d15f5e2b4b5092a61219"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        '8ce3839e-2a35-149b-8c70-921387a656ed'
                                      ),
                                      EText(
                                        '89b50107-cd85-1ac0-949b-4d4b42a224f4'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '4255b2b0-22eb-623b-366b-d99d2c383010',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Heading')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('h3'),
                                    styleBlockIds: EList([
                                      EText(
                                        'b923fc46-ce8e-0dc7-eabd-159942483cee'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '4255b2b0-22eb-623b-366b-d99d2c383011',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Sponsored sections'),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '45fe2a95-816d-5aa9-7687-cdb7d8fd4285',
      type: 'class',
      name: 'Gallery Scroll',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '916ee694-47ba-1d95-3e1c-70b5cf389d87',
      type: 'class',
      name: 'Gallery Wrapper',
      comb: '',
      styleLess:
        'display: grid; align-items: start; grid-auto-columns: 1fr; grid-column-gap: 40px; grid-row-gap: 40px; grid-template-columns: 1fr 1fr 1fr; grid-template-rows: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'grid-template-columns: 1fr 1fr;'},
        tiny: {styleLess: 'grid-template-columns: 1fr;'},
      },
    },
    {
      _id: '0b18eff6-31dd-044f-db61-66904ddcb3be',
      type: 'class',
      name: 'Gallery Sticky',
      comb: '',
      styleLess:
        'position: sticky; top: 80px; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;',
      children: [],
      variants: {medium: {styleLess: 'position: relative; top: 0px;'}},
    },
    {
      _id: 'cf7caa89-d314-3574-0a3d-36f50dcba0be',
      type: 'class',
      name: 'Gallery Link',
      comb: '',
      styleLess:
        'margin-bottom: 35px; color: #1a1b1f; font-size: 24px; line-height: 32px; text-decoration: none;',
      children: [],
      variants: {
        main_current: {styleLess: 'font-weight: 600;'},
        main_hover: {styleLess: 'color: hsla(228, 8.77%, 11.18%, 0.80);'},
      },
    },
    {
      _id: '0aedf519-3b74-1865-e2e4-926f45382757',
      type: 'class',
      name: 'Gallery Grid',
      comb: '',
      styleLess:
        'display: grid; grid-auto-columns: 1fr; grid-row-gap: 40px; grid-template-columns: 1fr; grid-template-rows: auto auto;',
      children: [],
      variants: {},
    },
    {
      _id: '560188c9-bb3e-d11f-21ba-bbadfd20abce',
      type: 'class',
      name: 'Gallery Image Wrapper',
      comb: '',
      styleLess: 'position: relative;',
      children: [],
      variants: {},
    },
    {
      _id: '8ce3839e-2a35-149b-8c70-921387a656ed',
      type: 'class',
      name: 'Gallery Image',
      comb: '',
      styleLess: 'width: 100%;',
      children: ['89b50107-cd85-1ac0-949b-4d4b42a224f4'],
      variants: {},
    },
    {
      _id: '89b50107-cd85-1ac0-949b-4d4b42a224f4',
      type: 'class',
      name: 'Shadow Two',
      comb: '&',
      styleLess: '',
      children: [],
      variants: {},
    },
    {
      _id: 'b923fc46-ce8e-0dc7-eabd-159942483cee',
      type: 'class',
      name: 'Gallery Image Text',
      comb: '',
      styleLess:
        'position: absolute; left: 16px; right: 16px; bottom: 16px; margin-bottom: 0px; color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {},
    },
  ],
} as const;
